export const formatPath = (value: string) => {
    const regex = /^(.+?)((\.[\w]+)+)$/
    const match = value?.match(regex)
    const path = [match?.[1] || '']

    return path
}
